import React from 'react'
import PartyLozenge from '../../Helpers/PartyLozenge'
import Party from '../../../models/Party'
import Utilities from '../../../utils/Utilities'
import { IPartyNumberMap } from '../../../models/TypeHelper'

interface IProps {
  outcomeCounts: IPartyNumberMap
  totalNumOutcomes: number
  header: string
}

const lozenges = (partyKey: string): JSX.Element => {
  const lozengeKeys =
    partyKey.indexOf('-') > -1 ? partyKey.split('-') : [partyKey]

  return (
    <React.Fragment>
      {lozengeKeys.map(
        (key: string): JSX.Element => (
          <PartyLozenge className="mr-2" key={key} party={Party.fromKey(key)} />
        )
      )}
    </React.Fragment>
  )
}

class OutcomeList extends React.Component<IProps> {
  public render(): JSX.Element {
    const { outcomeCounts, header, totalNumOutcomes } = this.props

    if (!(outcomeCounts && Object.keys(outcomeCounts).length > 0)) {
      return <div />
    }

    return (
      <React.Fragment>
        <h4>{header}</h4>
        <table className="table">
          <tbody>
            {Object.keys(outcomeCounts).map(
              (partyKey: string): JSX.Element => {
                return (
                  <tr key={partyKey}>
                    <td>{lozenges(partyKey)}</td>
                    <td className="text-muted">
                      <small>
                        <h4 className="d-inline">
                          {Utilities.formatPercent(
                            outcomeCounts[partyKey] / totalNumOutcomes,
                            0
                          )}{' '}
                        </h4>
                        of all outcomes
                      </small>
                    </td>
                  </tr>
                )
              }
            )}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}

export default OutcomeList
